<script lang="ts">
    import { Evento } from "./Evento";
    import EventoRenderer from "./Evento.svelte";
    import DonutSpinner from "./DonutSpinner.svelte";
    import ModalWindow from "./ModalWindow.svelte";
    import ProponiEvento from "./InternoModalWindow/ProponiEvento.svelte";
    import FeedRSS from "./InternoModalWindow/FeedRSS.svelte";
    import TOML from "toml";
import FeedRss from "./InternoModalWindow/FeedRSS.svelte";

    let fetch_events = fetch("/api/eventi")
    .then( (x)=>x.json())
        .then((x)=>{
            let ev = [];
            let lista_ogg_evento: Evento[] = [];
            x.eventi.forEach(element => {
                let e = new Evento(null, null, null, null, null, null);
                e.da_json(element);
                lista_ogg_evento.push(e);

                lista_ogg_evento.sort( (a, b) => new Date(a.data).getTime() - new Date(b.data).getTime() );
                lista_ogg_evento.reverse()
            });
            
            
            return lista_ogg_evento;
        })
        .catch(()=>{
            return [
                // new Evento(1, "2022-01-01", "05:05", "ABC", 0, "A")
            ]
        })
        ;

    
</script>

<div class="row">
    <h2>Eventi</h2>
    <!-- <ModalWindow
        identificativo="aggiungi_ev_modal"
        titolo="Proponi un evento"
        testo_pulsante="+"
        componente_interno={ProponiEvento}
    /> -->
    <a class="button" href="/admin/eventi/evento/add/">+</a>
    <ModalWindow
        identificativo="feed_rss"
        titolo="Notifiche RSS"
        testo_pulsante="Notifiche RSS"
        icon_class="icon-rss"
        componente_interno={FeedRss}
    />
</div>
<div class="row">
    {#await fetch_events }
    <DonutSpinner></DonutSpinner>
    {:then eventi}
        {#each eventi as e}
            <EventoRenderer evento={e}></EventoRenderer>
        {/each}
    {:catch error}
    <p>{error}</p>
    {/await}
</div>